var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{attrs:{"title":"Settings","current-name":_vm.$options.name,"items":_vm.items}},[_c('h1',[_vm._v("ตั้งค่าไรดีนะอิอิ")])])}
var staticRenderFns = []

export { render, staticRenderFns }